<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <v-dialog v-model="dialog.delete" persistent max-width="400">
      <v-card class="pa-3">
        <v-card-title class="title">Peringatan !</v-card-title>
        <v-card-text>Apakah anda yakin ingin menghapus data ini ?</v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="70"
            color="red"
            elevation="0"
            :disabled="process.form"
            :loading="process.form"
            class="white--text text-capitalize"
            @click="deletes">
            Yakin
          </v-btn>
          <v-btn
            rounded
            small
            width="70"
            elevation="0"
            class="text-capitalize"
            :disabled="process.form"
            @click="dialog.delete = false; type = ''">
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog 
      v-model="dialog.pic" 
      persistent
      width="650">
      <v-card class="pa-5">
        <v-img
          width="100%" 
          height="400px" 
          :src="detail.userUrlImg"
          playsinline 
          controls>
        </v-img>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            rounded
            width="150"
            elevation="0"
            class="text-capitalize mt-5 mb-0"
            @click="dialog.pic = false;">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.detail" persistent max-width="400">
      <v-card class="pa-3">
        <div class="body-1 text--secondary mb-5">
          Detail Admin
        </div>
        <div class="text-center">
          <v-avatar
            width="100" 
            height="100">
            <v-img 
              width="100" 
              height="100"
              :src="detail.userUrlImg" 
              class="mx-auto br-20 cursor-pointer">
            </v-img>
          </v-avatar>
        </div>
        <div class="mt-10">
          <v-list-item-title
            class="body-2 grey--text text--darken-2">
            <p class="caption grey--text text-lighten-4 mb-1">
              Nama
            </p>
            {{detail.userFullname}}
          </v-list-item-title>
          
          <v-list-item-title  
            class="body-2 grey--text text--darken-2 mt-2">
            <p class="caption grey--text text-lighten-4 mb-1">
              Telepon
            </p>
            {{ detail.userPhoneNumber !== '' ? detail.userPhoneNumber : 'xxxx-xxxx-xxxx' }}
          </v-list-item-title>

            <v-list-item-title
            class="body-2 grey--text text--darken-2 mt-2">
            <p class="caption grey--text text-lighten-4 mb-1">
              Email
            </p>
            {{detail.userEmail}}
          </v-list-item-title>
          <p class="caption grey--text text-lighten-4 mb-1 mt-3">
            Deskripsi
          </p>
          <p class="body-2 grey--text text--darken-2"
            v-if="detail.userDesc"
            v-html="detail.userDesc !== '' ? convert(detail.userDesc) : '-'">
          </p>
          <p class="caption grey--text text-lighten-4 mb-1 mt-3">
            Hak Akses
          </p>
          <div v-if="detail.userPrivilege">
            <div v-if="detail.userPrivilege.length > 0">
              <v-list
                color="transparent"
                dense
                nav
                v-for="(item, index) in detail.userPrivilege"
                :key="index"
                class="py-0">
                <v-list-item
                  :value="true">
                  <v-list-item-icon class="mr-3">
                    <v-icon>{{ item.menuIcon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.menuTitle }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="caption font-weight-light font-italic">
                      {{ item.menuUrl }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  :v-if="item.menuSubmenu.length > 0"
                  v-for="(sub, index) in item.submenuDetail"
                  :key="index"
                  class="pl-10">
                  <v-list-item-icon class="mr-3">
                    <v-icon>{{ sub.submenuIcon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ sub.submenuTitle }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="caption font-weight-light font-italic">
                      {{ sub.submenuUrl }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
            <div 
              class="grey--text text--darken-2 font-weight-bold caption"
              v-if="detail.userPrivilege.length < 1">
              Belum tersedia hak akses
            </div>
          </div>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              small
              width="100"
              elevation="0"
              class="text-capitalize"
              @click="dialog.detail = false">
              Tutup
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" :sm="showPage === false ? '12' : '8'">
        <div :class="$vuetify.breakpoint.name !== 'xs' ? 'd-flex': ''">
          <v-text-field
            filled
            rounded
            dense
            color="#ff618a"
            :hide-details="true"
            placeholder="Cari admin . . ."
            v-model="filter.username"
            clearable
            @click:clear="filter.username = ''; fetch();showPage = false;"
            v-on:keyup.enter="fetch();showPage = false"
            prepend-inner-icon="mdi-magnify">
          </v-text-field>
          <v-btn
            :color="!showPage ? '#ff618a' : '#F5F5F5'"
            :width="$vuetify.breakpoint.name === 'xs' ? '100%' : '200'"
            class="text-capitalize"
            :class="$vuetify.breakpoint.name === 'xs' ? 'mt-3' : 'mx-3'"
            :dark="!showPage"
            elevation="0"
            rounded
            :to="!showPage ? `/admin/general` : ''"
            :light="showPage"
            @click="showPage ? showPage = false : false">
            <span v-if="!showPage">Tambah Admin</span>
            <span v-if="showPage">Kembali</span>
          </v-btn>
        </div>

        <div class="my-5">
          <div class="title text--secondary">Data Admin</div>
          <div class="caption text--secondary">{{pagination.totalData}} Admin Ditemukan</div>
          <v-skeleton-loader
             class="ma-auto"
            :loading="process.run"
            transition="scale-transition"
            :tile="false"
            type="list-item-avatar-two-line"
            v-for="(l, index) in process.run ? 10:list"
            :key="index">
            <v-list dense class="line my-3 mr-5">
              <v-list-item>
                <v-list-item-avatar @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer mr-3">
                  <v-img :src="l.userUrlImg"></v-img>
                </v-list-item-avatar>
                <v-list-item-content @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer">
                  <v-list-item-title class="body-2 font-weight-bold grey--text text--darken-2">
                    {{ l.userFullname }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption mt-1 font-weight-thin" v-if="$vuetify.breakpoint.name !== 'xs'">
                    Nama
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer"
                  v-if="$vuetify.breakpoint.name !== 'xs'">
                  <v-list-item-title class="body-2 grey--text text--darken-2 d-flex">
                    <v-icon class="mr-2">mdi-email</v-icon>{{ l.userEmail }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption mt-1 font-weight-thin">
                    Email
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer"
                  v-if="$vuetify.breakpoint.name !== 'xs'">
                  <v-list-item-title class="body-2 grey--text text--darken-2 d-flex">
                    <v-icon class="mr-2">mdi-phone</v-icon>{{ l.userPhoneNumber }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption mt-1 font-weight-thin">
                    Telepon
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content class="text-right">
                  <div>
                    <v-btn 
                      fab
                      x-small
                      dark
                      color="#269B91"
                      elevation="0"
                      class="text-capitalize ma-1"
                      :to="`/admin/general?id=${l.id}`">
                      <v-icon small>mdi-square-edit-outline</v-icon>
                    </v-btn>
                    <v-btn 
                      fab
                      x-small
                      :disabled="process.form"
                      color="red"
                      elevation="0"
                      class="text-capitalize white--text ma-1"
                      @click="userId = l.id; dialog.delete = true">
                      <v-icon small>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-skeleton-loader>
          <Empty v-show="!process.run && list.length < 1" content="Data Admin"/>
          <div v-if="pagination.totalPage > 1">
            <v-row>
              <v-col cols="5">
                <div class="body-2 font-weight-bold mt-4">Total {{ pagination.totalData }} data</div>
              </v-col>
              <v-col cols="7">
                <div class="float-right">
                  <v-pagination
                    v-model="page"
                    :length="pagination.totalPage"
                    :total-visible="5"
                    color="#FF618A"
                    @input="fetch(page);showPage = false"
                    circle>
                  </v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>

      <v-col cols="12" sm="4" class="mt-3 background-default pa-7" v-if="showPage">
        <div>
          <div class="text-center">
            <v-avatar
              width="100" 
              height="100">
              <v-img 
                width="100" 
                height="100"
                :src="detail.userUrlImg" 
                @click="dialog.pic = true"
                class="mx-auto br-20 cursor-pointer">
              </v-img>
            </v-avatar>
          </div>
          <div class="mt-10">
            <v-list-item-title
              class="body-2 grey--text text--darken-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Nama
              </p>
               {{detail.userFullname}}
            </v-list-item-title>
            <v-list-item-title  
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Telepon
              </p>
              {{ detail.userPhoneNumber !== '' ? detail.userPhoneNumber : 'xxxx-xxxx-xxxx' }}
            </v-list-item-title>
             <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Email
              </p>
              {{detail.userEmail}}
            </v-list-item-title>
            <p class="caption grey--text text-lighten-4 mb-1 mt-3">
              Deskripsi
            </p>
            <p 
              class="body-2 grey--text text--darken-2"
              v-html="detail.userDesc !== '' ? convert(detail.userDesc) : '-'">
            </p>
          </div>
          <p class="caption grey--text text-lighten-4 mb-1 mt-3">
            Hak Akses
          </p>
          <div v-if="detail.userPrivilege.length > 0">
            <v-list
              color="transparent"
              dense
              nav
              v-for="(item, index) in detail.menuDetail"
              :key="index"
              class="py-0">
              <v-list-item
                :value="true">
                <v-list-item-icon class="mr-3">
                  <v-icon>{{ item.menuIcon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.menuTitle }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption font-weight-light font-italic">
                    {{ item.menuUrl }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                :v-if="item.menuSubmenu.length > 0"
                v-for="(sub, index) in item.submenuDetail"
                :key="index"
                class="pl-10">
                <v-list-item-icon class="mr-3">
                  <v-icon>{{ sub.submenuIcon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ sub.submenuTitle }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption font-weight-light font-italic">
                    {{ sub.submenuUrl }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
          <div 
            class="grey--text text--darken-2 font-weight-bold caption"
            v-if="detail.userPrivilege.length < 1">
            Belum tersedia hak akses
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  import Empty from "../../../components/DataEmpty";
  export default {
    data() {
      return {
        dialog: false,
        showPage: false,
        dialog: {
          delete: false,
          detail: false,
          pic:false
        },
        list: [],
        pagination: {},
        page: 1,
        detail: {},
        userId: '',
        filter: {
          username: ""
        },
        process: {
          run: false,
          form: false
        }
      };
    },
    components: {
      Empty 
    },
    mounted () {
      window.scrollTo(0, 0)
      this.fetch()
    }, 
    methods: {
      async fetch(p) {
        this.process.run = true
        await get(`api/internal/users/list`, {
          params: {
            pagenum: p,
            search:this.filter.username ? 'user_name:'+this.filter.username+',user_phone_number:'+this.filter.username+',user_email:'+this.filter.username : '',
            type: 'admin'
          }
        })
        .then((response) => {
          let res = response.data
          if (res.code === 200) {
            this.process.run = false
            this.list = res.data
            this.pagination = res.pagination
          }
        })
      },
      toDetail(item, status) {
        this.detail = item
        this.showPage = status !== undefined ? false : true
        this.dialog.detail = status !== undefined ? true : false
      },
      convert(item) {
        return item.replace(/&lt;/g, '<')
      },
      async deletes(){
         this.process.form = true;
         await destroy(`api/internal/users/delete/${this.userId}`)
         .then((response) => {
           let res = response.data;
           if(res.code == 201){
            this.process.form = false
            this.dialog.delete = false
            this.showPage = false
            this.fetch()
           }else{
            this.process.form = false
            this.response = res.msg
           }
         })
      }
    }
  };
</script>